"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@ory/elements-react/theme/styles.css");
require("./styles/index.css");
